import { useHasMenu } from 'auth/access';
import { AnalystProjectView } from '../analyst';
import { EmployeeProjectView } from '../employee';

/**
 * Picks the project screen by menu grant rather than role name: whoever may add/edit projects and
 * assign work (projects.projects EDIT — admin always) gets the analyst view, whose APIs
 * (`/api/analyst/**`) need that same grant; everyone else gets the employee view of their own
 * tasks on the project (`/api/employee/{self}/job/{id}`), which is read-only apart from their own
 * task timer and submissions.
 */
export default function ProjectViewByRole() {
  const canManageProjects = useHasMenu('projects.projects', 'EDIT');

  return canManageProjects ? <AnalystProjectView /> : <EmployeeProjectView />;
}
